<template>
  <Main bg="." style="overflow-x: clip">
    <div slot="main" class="main">
      <div class="bank_title">
        <Header :data='headerInfo'></Header>
      </div>
      <div class="content">
        <div>
          <el-input v-model="input" @keyup.enter="sreach" placeholder="请输入溯源码"></el-input>
          <el-button type="primary" class="btn" @click="sreach">查询</el-button>
        </div>
        <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
      </div>
    </div>
  </Main>
</template>

<script>
import Main from "../../components/main.vue";
import Header from "../../components/headerXn.vue";
export default {
  components: {
    Main,
    Header
  },
  data() {
    return {
      userInfo: {},
      headerInfo: {},
      input: ''
    };
  },
  watch: {},
  mounted() {
    this.headerInfo = {
      name: window.localStorage.getItem('screenName')
    }
  },
  created() {
    var _this = this;
    document.addEventListener("keydown", _this.watchEnter);
  },
  destroyed() {
    //移除监听回车按键
    var _this = this;
    document.removeEventListener("keydown", _this.watchEnter);
  },
  methods: {
    sreach() {
      if (!this.input) {
        this.$message.error('请输入溯源码！');
        return
      }
      this.$router.push({ name: 'traceInfoXn' })

    },
    //监听回车按钮事件
    watchEnter(e) {
      var keyNum = window.event ? e.keyCode : e.which; //获取被按下的键值
      //判断如果用户按下了回车键（keycody=13）
      if (keyNum == 13) {
        this.sreach()
      }
    },
  },
  beforeCreate() {
    // window.document.body.style.backgroundColor = "#001725";
  },
  beforeDestroy() {
    // window.document.body.style.backgroundColor = "#000";
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;

  .content {
    position: relative;
    // min-height: calc(100vh - 1rem);
    min-height: 12.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    // background-image: url("../../assets/bg-hhr.png");
    // background-size: 100% 100%;
    video {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
    }

    div {
      display: flex;

      .el-input {
        width: 5.5rem;

        .el-input__inner {
          width: 5.5rem;
        }
      }

      .btn {
        width: 1.2rem;
      }

    }
  }
}

::v-deep .el-button--primary {
  color: #FFF;
  background-color: #00E0DB !important;
  color: #032929 !important;
}
</style>